import styled from 'styled-components'

export const OrderReportContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
`
